import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { successToastMessage } from '../../../../../components/layout/toast-root/toast';
import { usePostPutProgramSet } from '../../../../../redux/api/programsAPI';
import { useGetMyDetails } from '../../../../../redux/api/users/usersApi';
import { ITrainingSet } from '../../../../../types/interfaces/training-set';
import { getProgramSetFromTrainingSet } from '../../../../../utils/training/set-utils';

export function useFinishedTrainingSetList(trainingSet: ITrainingSet) {
  const [showSaveSetModal, setShowSaveSetModal] = useState(false);
  const { data: user } = useGetMyDetails();
  const [postPutProgramSet] = usePostPutProgramSet();
  const { t } = useTranslation();

  function onSaveSet(title: string) {
    const newProgramSet = getProgramSetFromTrainingSet(trainingSet);
    newProgramSet.title = title;
    newProgramSet.ownerId = user?.id;
    newProgramSet.setNumber = 0;
    newProgramSet.orderNumber = 0;
    newProgramSet.exercise = null;

    return postPutProgramSet({
      setId: undefined,
      body: newProgramSet,
    })
      .unwrap()
      .then((response) => {
        setShowSaveSetModal(false);
        successToastMessage(t('setTable.setSaved'));
        return response;
      })
      .catch((e) => {
        console.log(e);
      });
  }

  return {
    showSaveSetModal,
    setShowSaveSetModal,
    onSaveSet,
  };
}
